// @ts-nocheck

export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6de87565" /* webpackChunkName: "config_i18n_46config_46ts_6de87565" */)
]
export const normalizedLocales = []

